import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Zap, Clock, Music, ShieldCheck } from "lucide-react";

const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export default function FinalCta({ content, onOrder }) {
  const [left, setLeft] = useState("");
  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      const d = Math.max(0, end - now);
      const p = (n) => String(n).padStart(2, "0");
      setLeft(`${p(Math.floor(d / 3.6e6))}:${p(Math.floor((d % 3.6e6) / 6e4))}:${p(Math.floor((d % 6e4) / 1e3))}`);
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, []);

  const price = content?.price ?? 2999;
  const original = content?.original_price ?? 5999;

  return (
    <section className="bg-pink border-t-[3px] border-ink py-20 sm:py-28 relative overflow-hidden" data-testid="final-cta-section">
      <span className="absolute top-10 left-[8%] text-white/20 float-note" aria-hidden="true"><Music size={44} /></span>
      <span className="absolute bottom-12 right-[10%] text-white/20 float-note" style={{ animationDelay: "1.4s" }} aria-hidden="true"><Music size={56} /></span>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
        <motion.div initial={{ opacity: 0, y: 32 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
          <span className="inline-flex items-center gap-2 rounded-full bg-ink text-sunny font-mono text-xs font-semibold px-5 py-2 border-2 border-ink" data-testid="offer-countdown">
            <Clock size={13} /> Offer ends in {left}
          </span>
          <h2 className="mt-6 font-display font-bold text-white text-5xl sm:text-6xl tracking-tight leading-[1.05]">
            {content?.finalcta_heading ?? "Make them feel it. Make them a song."}
          </h2>
          <p className="mt-4 text-white/90 font-medium max-w-md mx-auto text-sm sm:text-base">
            {content?.finalcta_subtitle ?? "One quick form today. A song they'll replay for years."}
          </p>

          <div className="mt-7 flex items-center justify-center gap-4">
            <span className="font-mono text-white/60 line-through text-lg">{inr(original)}</span>
            <span className="font-display font-bold text-5xl text-sunny" data-testid="final-price">{inr(price)}</span>
          </div>

          <button
            data-testid="final-create-song-button"
            onClick={onOrder}
            className="btn-pop mt-8 rounded-full bg-sunny text-ink font-head font-bold px-10 py-4 text-sm sm:text-base border-[3px] border-ink shadow-[6px_6px_0_#2D1A32]"
          >
            Order Your Custom Song Now
          </button>

          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg mx-auto">
            {[
              [Zap, "12-hr delivery"],
              [ShieldCheck, content?.guarantee_text ?? "Happiness guarantee"],
              [Music, "MP3 forever"],
            ].map(([Icon, t], i) => (
              <div key={i} className="rounded-2xl bg-white/15 border-2 border-white/40 p-4 backdrop-blur-sm">
                <Icon size={18} className="text-sunny mx-auto" />
                <p className="mt-2 text-[11px] sm:text-xs font-head font-semibold text-white">{t}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
